import React, { useState } from 'react';
import './Rotaryinje.css';
import IBMRotary1 from '../../../imgs/IBMRotary1.webp';
import IBMRotary2 from '../../../imgs/IBMRotary2.webp';
import IBMRotary3 from '../../../imgs/IBMRotary3.webp';
import IBMRotary4 from '../../../imgs/IBMRotary4.webp';
import Reqprodcte from "../../../components/Reqprodcte";


const images = [
    { src: IBMRotary1 },
    { src: IBMRotary2 },
    { src: IBMRotary3 },
    { src: IBMRotary4 },
];

const Rotaryinje = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="Rotaryi-main-container">
            {/* Left: Slideshow */}
            <div className="Rotaryi-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"} key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            {/* Right: Text Section */}
            <div className="Rotaryi-text">
                <h2>Rotary Injection Blow Molding Machine</h2>
                <h3>IBM-R SERIES</h3>
                <p>
                    IBM-R Series Rotary Injection Blow Molding Machine with rotary mold system for good surface finishing products like: LED bulb cover, cosmetics bottle etc.</p>
                <ul>
                    <li><strong>Clamping Force</strong>  – 2000~3300(KN)</li>
                    <li><strong>Driving System:</strong>  Hydraulic</li>
                    <li><strong>Motor Type:</strong> Servo</li>
                    <li><strong> Hydraulic-</strong> LED Bulb,Cosmetics Packaging & Bottl</li>
                </ul>
               <div className='stnd'>
                    <Reqprodcte />
                </div>     
                     </div>
        </div>
    );
};

export default Rotaryinje;
